import BaseCollection from '../../common/collections/baseCollection';
import PermissionFilter from './permissionFilter';

const PermissionFilterCollection = BaseCollection.extend({
	model: PermissionFilter
});

export default PermissionFilterCollection;
